<script setup lang="ts">
import { defineEmits, defineProps, Ref, ref } from "vue";
import { useField } from "vee-validate";
import ErrorText from "@/components/Texts/ErrorText.vue";

const props = defineProps<{
  name: string;
  placeholder: string;
  id: string;
  is_required: boolean;
  modelValue: number;
}>();

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(props.name, undefined, {
  initialValue: props.modelValue,
});
const emit = defineEmits(["update:modelValue"]);

const updateValue = ($event: Event) => {
  emit("update:modelValue", ($event.target as HTMLInputElement).value);
  handleChange($event);
};
</script>

<template>
  <div class="flex flex-col space-y-2">
    <input
      type="number"
      class="placeholder-gray-400 focus:backdrop-blur-sm focus:border-purple-700 bg-opacity-10 bg-transparent border border-white rounded-lg px-4 py-2 text-[#e2e1e5] transition duration-200 shadow-md w-2/3 md:w-1/2"
      :name="props.name"
      :placeholder="props.placeholder"
      :id="props.id"
      :required="props.is_required"
      :value="modelValue || inputValue"
      @input="updateValue($event)"
      @blur="handleBlur"
    />
    <ErrorText v-if="errorMessage" :text="errorMessage" />
  </div>
</template>
